"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// TODO - see what's actually used
const style = "\n\t.react-timekeeper-button-reset {\n\t\tbackground: 0;\n\t\tborder: 0;\n\t\tbox-shadow: none;\n\t\ttext-shadow: none;\n\t\t-webkit-appearance: none;\n\t\t-moz-appearance: none;\n\t\tcursor: pointer;\n\t}\n\t.react-timekeeper-button-reset:hover, .react-timekeeper-button-reset:focus, .react-timekeeper-button-reset:active {\n\t\toutline: none;\n\t}\n\t.react-timekeeper-button-reset::-moz-focus-inner {\n\t\tborder: 0;\n\t\tpadding: 0;\n\t}\n\t.react-timekeeper-noscroll {\n\t\toverflow: hidden;\n\t}\n\t.react-timekeeper-scrollbar-measure {\n\t\twidth: 100px;\n\t\theight: 100px;\n\t\toverflow: scroll;\n\t\tposition: absolute;\n\t\ttop: -9999px;\n\t}\n";
var _default = style;
exports.default = _default;